import styled from 'styled-components';
import React from "react";

export const StyledImage = styled.img`
  margin: 0;
  width: auto;
  padding-bottom: 3px;
`;
